import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';
import { AiOutlineCloudUpload } from 'react-icons/ai';
const tiles = [
  {
    sNo: 1,
    link: '/common/clauseUploadList?documentType=manMachineMatrixClause3Pdc&heading=MAN MACHINE MATRIX',
    isLink: true,
    clauseNo: 3,
    icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
    p: 'MAN MACHINE',
    span: 'MATRIX',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/clauseUploadList?documentType=wiClause3Pdc&heading=WI',
    isLink: true,
    clauseNo: 3,
    icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
    p: 'WI',
    span: '',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/common/clauseUploadList?documentType=breakdownReferenceForMachineClause3Pdc&heading=BREAKDOWN REFERENCE FOR MACHINE MAINTENANCE',
    isLink: true,
    clauseNo: 3,
    icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
    p: 'BREAKDOWN REFERENCE FOR',
    span: 'MACHINE MAINTENANCE',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/clauseUploadList?documentType=breakdownReferenceForToolClause3Pdc&heading=BREAKDOWN REFERENCE FOR TOOL/DIE MAINRENANCE',
    isLink: true,
    clauseNo: 3,
    icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
    p: 'BREAKDOWN REFERENCE FOR',
    span: 'TOOL/DIE MAINTENANCE',
    isIcon: true,
  },
];

export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];
const PdcHome = () => {
  return (
    <>
      <ChildHeader text="4M PDC" />
      <RenderTiles tilesObj={tiles} height="100vh" />
    </>
  );
};

export default PdcHome;
